import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { showToast } from "./Toast";

const BASE_URL = "https://api.shubhamraj01.in";

export default function AuthModal({ mode, setMode, onClose }) {
  const { saveToken, setCurrentUser } = useAuth();
  const [form, setForm]   = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isLogin = mode === "login";

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    setError("");
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.email || !form.password) { setError("Please fill all fields"); return; }
    if (!isLogin && !form.name)        { setError("Please enter your name"); return; }
    setLoading(true);
    try {
      let res, data;
      if (isLogin) {
        res  = await fetch(`${BASE_URL}/auth/signin`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: form.email, password: form.password }),
        });
      } else {
        res = await fetch(`${BASE_URL}/auth/signup`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fullName: form.name, email: form.email, password: form.password, role: "ROLE_CUSTOMER" }),
        });
      }
      data = await res.json();
      if (!res.ok) throw new Error(data.message || "Something went wrong");

      saveToken(data.jwt);

      // Fetch profile
      const profileRes = await fetch(`${BASE_URL}/api/users/profile`, {
        headers: { Authorization: `Bearer ${data.jwt}` },
      });
      const profile = await profileRes.json();
      setCurrentUser(profile);

      showToast(isLogin ? "👋 Welcome back!" : "🎉 Account created!");
      onClose();
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      onClick={e => e.target === e.currentTarget && onClose()}
      style={{
        position: "fixed", inset: 0, background: "rgba(28,24,20,.5)",
        zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center",
        padding: "1rem",
      }}
    >
      <div style={{
        background: "var(--surface)", border: "1.5px solid var(--border)",
        borderRadius: "24px", width: "100%", maxWidth: "420px",
        padding: "2rem", position: "relative",
      }}>
        {/* Close */}
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: "1rem", right: "1rem",
            width: "32px", height: "32px", borderRadius: "8px",
            border: "1.5px solid var(--border)", background: "transparent",
            color: "var(--text2)", cursor: "pointer", fontSize: "1rem",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >✕</button>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "1.75rem" }}>
          <div style={{
            fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: "1.5rem",
            marginBottom: ".75rem",
          }}>
            🍽 Sa<span style={{ color: "var(--primary)" }}>v</span>ora
          </div>
          <h3 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: "1.3rem" }}>
            {isLogin ? "Welcome back" : "Create account"}
          </h3>
          <p style={{ color: "var(--text2)", fontSize: ".88rem", marginTop: ".25rem" }}>
            {isLogin ? "Sign in to continue" : "Join Savora today"}
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {!isLogin && (
            <div style={{ marginBottom: "1rem" }}>
              <label style={{ fontSize: ".8rem", fontWeight: 600, color: "var(--text2)", display: "block", marginBottom: ".4rem" }}>Full Name</label>
              <input
                type="text" name="name" value={form.name} onChange={handleChange}
                placeholder="Shubham Kumar"
                style={{
                  width: "100%", padding: ".65rem 1rem", borderRadius: "10px",
                  border: "1.5px solid var(--border)", background: "var(--bg)",
                  color: "var(--text)", fontSize: ".9rem", outline: "none",
                  fontFamily: "inherit",
                }}
              />
            </div>
          )}

          <div style={{ marginBottom: "1rem" }}>
            <label style={{ fontSize: ".8rem", fontWeight: 600, color: "var(--text2)", display: "block", marginBottom: ".4rem" }}>Email</label>
            <input
              type="email" name="email" value={form.email} onChange={handleChange}
              placeholder="you@example.com"
              style={{
                width: "100%", padding: ".65rem 1rem", borderRadius: "10px",
                border: "1.5px solid var(--border)", background: "var(--bg)",
                color: "var(--text)", fontSize: ".9rem", outline: "none",
                fontFamily: "inherit",
              }}
            />
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label style={{ fontSize: ".8rem", fontWeight: 600, color: "var(--text2)", display: "block", marginBottom: ".4rem" }}>Password</label>
            <input
              type="password" name="password" value={form.password} onChange={handleChange}
              placeholder="••••••••"
              style={{
                width: "100%", padding: ".65rem 1rem", borderRadius: "10px",
                border: "1.5px solid var(--border)", background: "var(--bg)",
                color: "var(--text)", fontSize: ".9rem", outline: "none",
                fontFamily: "inherit",
              }}
            />
          </div>

          {error && (
            <div style={{
              background: "#fee2e2", color: "#991b1b", borderRadius: "8px",
              padding: ".6rem .9rem", fontSize: ".83rem", marginBottom: ".75rem",
            }}>
              {error}
            </div>
          )}

          <button
            type="submit" disabled={loading}
            style={{
              width: "100%", background: "var(--primary)", color: "#fff",
              border: "none", padding: ".85rem", borderRadius: "12px",
              fontWeight: 700, fontSize: ".95rem", cursor: "pointer",
              opacity: loading ? .6 : 1, fontFamily: "inherit",
            }}
          >
            {loading ? "Please wait..." : isLogin ? "Sign In" : "Create Account"}
          </button>
        </form>

        {/* Toggle */}
        <p style={{ textAlign: "center", marginTop: "1.25rem", fontSize: ".85rem", color: "var(--text2)" }}>
          {isLogin ? "Don't have an account? " : "Already have an account? "}
          <a
            onClick={() => setMode(isLogin ? "signup" : "login")}
            style={{ color: "var(--primary)", cursor: "pointer", fontWeight: 600 }}
          >
            {isLogin ? "Sign up" : "Sign in"}
          </a>
        </p>
      </div>
    </div>
  );
}